module.exports = __webpack_public_path__ + "analytics-hero.svg";